import { Accordion, Container } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import HeaderTabs from "../../../components/Header2Tabs";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/faq.css"; // import custom styles (see below)
import { AppContext } from "../../../ContextApi";
import { useContext, useState, useEffect } from "react";
import { emptyFaqBanner } from "../../../Assets";

const FAQ = () => {
  const { activeElementId, mainAPikey, requestOptions } =
    useContext(AppContext);
  const [token, setToken] = useState(
    localStorage.getItem("authorizationToken") || ""
  );
  const [FaqData, setFaqData] = useState([]);

  useEffect(() => {
    const getFAQlist = async () => {
      if (token && activeElementId) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/${mainAPikey}/employee/faq-list?policy_id=${activeElementId}`,
            requestOptions
          );
          const authToken = response.headers.get("authorizationToken");
          if (authToken) {
            localStorage.setItem("authorizationToken", authToken);
          }

          const res = await response.json();

          if (res.success) {
            setFaqData(res?.data);
          } else {
            setFaqData([]);
            // Handle error if needed
          }
        } catch (error) {
          console.error("Error fetching forms list:", error);
        }
      }
    };

    getFAQlist();
  }, [token, activeElementId]);

  return (
    <>
      <div className="main-escalation-cover-wrapper claim-app-home-main-cover-wrapper">
        <HeaderTabs />
        <div className="separater-box"></div>

        <div className="faq-main-cover-wrapper pt-0 py-4">
          <div className="network-hospital-heading mb-4">
            <h3 className="text-center">FAQ's</h3>
          </div>
          <Container>
            {FaqData?.length > 0 ? (
              <Accordion defaultActiveKey="0" className="minimal-accordion">
                { FaqData.map((faq, index) => (
                  <Accordion.Item eventKey={index.toString()} key={faq.sr_no}>
                    <Accordion.Header className="faq-header">
                      {faq.question}
                    </Accordion.Header>
                    <Accordion.Body className="faq-body">
                      <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
              
            ) : (
              <div className="empty-banner-cover-wrapper">
                  <img src={emptyFaqBanner} alt="No Faq found"></img>
                  <p>No FAQ's found.</p>
              </div>
            )}            
          </Container>
        </div>

        <ToastContainer position="top-center" />
      </div>
    </>
  );
};

export default FAQ;
